import { Table, Tbody, Td, Th, Thead, Tr, Text } from "@chakra-ui/react";
import { DownloadFileIcon } from "lib/icons/downloadFile";
import { baseRESTUrl } from "lib/utils";
import { useLoggedinUser, useTeamInvoices } from "lib/hooks";
import { VerifyEmailAlert } from "components";

export const ListInvoices = () => {
  const { isVerified } = useLoggedinUser();
  const { data: invoices } = useTeamInvoices();

  if (!isVerified && !!invoices) {
    return <VerifyEmailAlert content={"Verify your email to view invoices."} />;
  }

  if (!invoices?.length && !!invoices) {
    return <Text>You have no invoices</Text>
  }

  return (
    <Table variant="simple" width="100%">
      <Thead>
        <Tr>
          <Th display={['none', 'table-header']}>Amount</Th>
          <Th>Date</Th>
          <Th display={['none', 'table-header']}>Has been paid?</Th>
          <Th>Download</Th>
        </Tr>
      </Thead>
      <Tbody>
        {
          invoices?.map(({ date, total, id, paid }) => (
            <Tr key={id}>
              <Td display={['none', 'table-cell']}>{total}</Td>
              <Td>{date}</Td>
              <Td display={['none', 'table-cell']}>{paid ? 'Yes' : 'No'}</Td>
              <Td>
                <a title="View Invoice" rel="noopener noreferrer" target="_blank" href={`${baseRESTUrl()}/v1/team/invoices/${id}`}>
                  <DownloadFileIcon boxSize="22px" style={{ marginTop: '-3px' }} />
                </a>
              </Td>
            </Tr>
          ))
        }
      </Tbody>
    </Table>
  )
}
